// extracted by mini-css-extract-plugin
export default {"main":"Main_main__FWsNc","closed":"Main_closed__BSaK6","SidebardivMob":"Main_SidebardivMob__JDFGz","brigosha":"Main_brigosha__xkHZX","Sidebardiv":"Main_Sidebardiv__XKZO8"};